<template>
  <BaseWrapper>
    <Tabs
      :tabs-data="[
        'Penjualan',
        'Kebijakan Wilayah Harga Stockist',
        'Kebijakan Wilayah Harga SC',
        'Kebijakan Wilayah Penjualan',
      ]"
      :tab-active="tabActive"
      @updateTabActive="(active) => (tabActive = active)"
    >
      <template #default="{ tabActive }">
        <SetupPenjualan v-if="tabActive === 'Penjualan'" />
        <SetupKebijakanWilayahHarga
          v-else-if="tabActive === 'Kebijakan Wilayah Harga Stockist'"
          destination-office-type="stockist"
          key="Kebijakan Wilayah Harga Stockist"
        />
        <SetupKebijakanWilayahHarga
          v-else-if="tabActive === 'Kebijakan Wilayah Harga SC'"
          destination-office-type="stockist_center"
          key="Kebijakan Wilayah Harga SC"
        />
        <SetupKebijakanWilayahPenjualan
          v-else
        />
      </template>
    </Tabs>
  </BaseWrapper>
</template>

<script>
import Tabs from '../../../../components/Tabs.vue';
import SetupKebijakanWilayahHarga from '../../../../components/admin/setup/SetupKebijakanWilayahHarga.vue';
import SetupKebijakanWilayahPenjualan from '../../../../components/admin/setup/SetupKebijakanWilayahPenjualan.vue';
import SetupPenjualan from '../../../../components/admin/setup/SetupPenjualan.vue';

export default {
  components: { Tabs, SetupPenjualan, SetupKebijakanWilayahHarga, SetupKebijakanWilayahPenjualan },
  data() {
    return {
      tabActive: 'Penjualan',
    };
  },
};
</script>
